<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Inversionistas</li>
            </ol>
        </nav>
        <div class="container">
            <div class="card">
                <div class="card-header">
                  <h5>Buscar inversionista</h5>
                  <ul>
                    <li>
                      <vs-radio
                          v-model="kind"
                          @change="newSearch"
                          vs-value="fiscal">
                        <strong>Personas físicas</strong>
                        <small>(person_type 1 y 2)</small>
                      </vs-radio>
                    </li>
                    <li>
                      <vs-radio
                          v-model="kind"
                          vs-value="moral"
                          @change="newSearch">
                        <strong>Personas morales</strong>
                        <small>(person_type 0 y 3)</small>
                      </vs-radio>
                    </li>
                  </ul>
                </div>
                <div class="card-body">
                    <form action="/api/investors" method="GET" @submit.prevent="newSearch()">
                      <vs-input
                          class="w-1/3"
                          icon="search"
                          v-model="term"
                          placeholder="Criterios de búsqueda: Nombre, Email, RFC, Beneficiario"
                          label="Buscar inversionistas"></vs-input>
                    </form>


                    <table class="table table-hover" id="investor-table" v-if="data.data.length > 0">
                        <thead class="thead-dark">
                        <th>ID</th>
                        <th>User ID</th>
                        <th>Nombre</th>
                        <th>Beneficiario</th>
                        <th>Email</th>
                        </thead>
                        <tbody>
                        <tr v-for="investor in data.data" @click="$router.push(`/investor/${investor.id}`)">
                            <td>{{investor.id}}</td>
                            <td>{{investor.user.id}}</td>
                            <td>{{investor.fiscal_name}}</td>
                            <td>{{investor.beneficiary}}</td>
                            <td>{{investor.email}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-else>
                      <p class="pt-3 text-center bold">No hay resultados</p>
                    </div>

                    <template v-if="data.data.length > 0">
                      <div class="flex gap-2">
                          <div class="mt-2">Mostrando del {{data.from}} al {{data.to}} de {{data.total}}</div>
                          <vs-button icon="keyboard_arrow_left" @click="changePage(prevPage)" :disabled="page === 1">
                          </vs-button>
                          <vs-button icon="keyboard_arrow_right" @click="changePage(nextPage)" :disabled="data.last_page === page">
                          </vs-button>
                      </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {AxiosErrorException} from "./functions/axiosErrorException.js";
    import AjaxPagination from './ajax-pagination.vue';

    export default {
        name: "Investors",
        components: {
            AjaxPagination
        },
        data: () => ({
            data: { data: [] },
            term: "",
            page: 1,
            onRequest: false,
            kind: 'fiscal',
        }),
        mounted() {
            this.find()
        },
        computed: {
            prevPage() {
                return this.page - 1;
            },
            nextPage() {
                return this.page + 1;
            }
        },
        methods: {
          async newSearch(){
            this.page = 1; // reiniciar pagina en nueva busqueda
            await this.find();
          },
          async find() {
            this.showLoading(true);
              try {
                  this.onRequest = true;
                  const { data } = await axios.get(`/api/investor?search=${this.term}&kind=${this.kind}&page=${this.page}`);
                  this.data = data;
                  this.showLoading(false);
              } catch (e) {
                  swal('Ups!', AxiosErrorException(e), 'error');
                  this.showLoading(false);
              } finally {
                  this.onRequest = false
                  this.showLoading(false);
              }
          },
          async changePage(page) {
              this.page = page
              this.find()
          }
        }
    }
</script>

<style lang="scss" scoped>
.md-radio {
  display: flex;
}
</style>
